import React from 'react';

import { Button, Stack, Typography } from '@mui/material';

interface BulkActionBarProps {
  selectedCount: number;
  isMutating: boolean;
  onBulkApprove: () => void;
  onBulkReject: () => void;
}

export default function BulkActionBar({ selectedCount, isMutating, onBulkApprove, onBulkReject }: BulkActionBarProps) {
  if (selectedCount === 0) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1} mb={1.5} alignItems="center">
      <Typography variant="body2">{selectedCount} selected</Typography>
      <Button size="small" variant="contained" disabled={isMutating} onClick={onBulkApprove}>
        Bulk approve ({selectedCount})
      </Button>
      <Button size="small" variant="text" color="error" disabled={isMutating} onClick={onBulkReject}>
        Bulk reject
      </Button>
    </Stack>
  );
}
